/**
 * Owner vs guest layout on My Bookings (/bookings).
 */

export const MY_BOOKINGS_OWNER_BANNER_TEST_ID = 'owner-dashboard-cta';

export function isOwnerBookingsContext({ canAccessOwner, isGuestContext }) {
  return Boolean(canAccessOwner && !isGuestContext);
}

/**
 * Owner context shows one Owner Dashboard CTA in the top banner only.
 */
export function getMyBookingsOwnerCtaLayout({ canAccessOwner, isGuestContext }) {
  const ownerContext = isOwnerBookingsContext({ canAccessOwner, isGuestContext });
  return {
    showTopOwnerBanner: ownerContext,
    showEmptyStateOwnerDashboardButton: false,
    ownerDashboardCtaCount: ownerContext ? 1 : 0,
  };
}

export function ownerDashboardCtaLabelKey() {
  return 'booking.owner_dashboard_link';
}
